import { EditFormWrapper } from "@/features/Edit/EditFormWrapper.tsx";
import { getAuthorized } from "@/lib/fetch.tsx";
import { a7FIACompositionsEditForm } from "@/pages/a7/EditForms/a7FIACompositionsEditForm.tsx";
import { Card, CardHeader, Divider } from "@heroui/react";
import { Spinner } from "@heroui/spinner";
import { useQuery } from "@tanstack/react-query";
import { Dispatch, SetStateAction, useEffect, useMemo } from "react";

export interface A7FIAInstrumentMultiEditCardProps {
  instrument_id: number;
  selectedDate?: string;
  instrument_type?: string;
  fund_id?: string;
  set_file_list: Dispatch<SetStateAction<Set<number>>>;
}

export function A7FIACompositionListMultiEditCard({
  instrument_id,
  selectedDate,
  instrument_type,
  fund_id,
  set_file_list,
}: A7FIAInstrumentMultiEditCardProps) {
  const fieldChangeCallBack = useMemo(
    () => ({
      a7_fia_time_serie_file_id: (file_id: number) =>
        set_file_list((fl) => new Set([...fl, file_id])),
    }),
    [set_file_list],
  );

  const { data: composition_id_list } = useQuery({
    queryKey: [
      "a7",
      "fia_multi_edit",
      "instrument_composition_id",
      instrument_id,
      selectedDate,
      fund_id,
    ],
    queryFn: async () => {
      const url = `${
        import.meta.env.VITE_BACKEND_URL
      }/a7/fia_multi_edit/instrument_composition_id/${instrument_id}/${selectedDate}${
        fund_id ? `?fund_id=${fund_id}` : ""
      }`;
      return getAuthorized(url).then(
        (response) => response.json() as Promise<number[] | undefined>,
      );
    },
    enabled: instrument_id != undefined && selectedDate != undefined,
  });

  useEffect(() => {
    set_file_list(new Set());
  }, [composition_id_list]);

  if (!composition_id_list)
    return (
      <Card>
        <Spinner />
      </Card>
    );

  return composition_id_list.map((composition_id) => (
    <Card>
      <CardHeader className="text-lg font-bold text-gray-700">
        Détention
      </CardHeader>
      <Divider />
      <div className="flex flex-col p-2">
        <EditFormWrapper
          client={"a7"}
          id={composition_id}
          {...a7FIACompositionsEditForm}
          allowDelete={false}
          fieldChangeCallBack={fieldChangeCallBack}
          multiFieldOptions={{
            default: { isVisible: false },
            a7_fia_instrument_from_name: { isVisible: true },
            valorisation_part_du_sous_jacent: { isVisible: true },
            detention_du_fonds_dans_le_sous_jacent: {
              isVisible: true,
              isDisabled: [
                undefined,
                "LOAN",
                "BOND",
                "CONVERTIBLE BOND",
              ].includes(instrument_type),
            },
          }}
        />
      </div>
    </Card>
  ));
}
